import axios from "axios";

const appURL =  process.env.REACT_APP_SIGN_IN_URL

export const getUserRedirectUrl = (username)=>{
  var config ={ 
    method: 'GET',
    url: appURL+`/redirectbyusername?username=${username}`,
    headers :{"Content-Type":"application/json"}
  };
  return axios(config);
}

export const getBannerSettings = (username)=>{
  var config ={ 
    method: 'GET',
    url: appURL+`/bannersettings${username ? "?username=" + username : ""}`,
    headers :{"Content-Type":"application/json"}
  };
  return axios(config);
}

export const signInUser = (username,password,redirect_uri,state)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/signin",
    headers :{"Content-Type":"application/json"},
    data : {username: username, password:password,AuthFlow:"CUSTOM_AUTH", redirect_uri: redirect_uri, state:state}  ,
  };
  return axios(config);
}

export const answerSelectMFAType = (username,answer,session,clientId)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/signin/answerselectmfa",
    headers :{"Content-Type":"application/json"},
    data : { ChallengeResponses: {USERNAME: username, ANSWER: answer}, ClientId: clientId,Session: session }  ,
  };
  return axios(config);
}
export const answerCustomSelectMFAType = (username,answer,session,clientId)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/signin/customanswerselectmfa",
    headers :{"Content-Type":"application/json"},
    data : { ChallengeResponses: {USERNAME: username, ANSWER: answer}, ClientId: clientId,Session: session }  ,
  };
  return axios(config);
}
export const answerSMSMFA = (username,answer,session,clientId)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/signin/answersms",
    headers :{"Content-Type":"application/json"},
    data : { ChallengeResponses: {USERNAME: username, SMS_MFA_CODE: answer}, ClientId: clientId, Session: session}  ,
  };
  return axios(config);
}

export const answerAuthAppMFA = (username,answer,session,clientId)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/signin/answerauthapp",
    headers :{"Content-Type":"application/json"},
    data : { ChallengeResponses: {USERNAME: username, SOFTWARE_TOKEN_MFA_CODE : answer}, ClientId: clientId,Session: session} ,
  };
  return axios(config);
}
export const answerEmailMFA = (username,answer,session,clientId)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/signin/answeremail",
    headers :{"Content-Type":"application/json"},
    data : { ChallengeResponses: {USERNAME: username, ANSWER : answer}, ClientId: clientId,Session: session} ,
  };
  return axios(config);
}

export const forgotPasswordRequest = (username,clientId )  => {
  
  var config ={ 
    method: 'POST',
    url: appURL+"/forgotpassword",
    headers :{"Content-Type":"application/json"},
    data : {ClientId: clientId, Username: username} ,
  };
  return axios(config);
}

export const confirmForgotPassword = (username, conformationCode, password,clientId )  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/confirmpassword",
    headers :{"Content-Type":"application/json"},
    data : {ClientId: clientId, Username: username,ConfirmationCode:conformationCode,Password:password} ,
  };
  return axios(config);

  // return httpCommon.post('/signin/forgotpassword', data)
  // var config ={ 
  //   method: 'POST',
  //   url: baseURL,
  //   headers :{"X-Amz-Target":"AWSCognitoIdentityProviderService.ConfirmForgotPassword","Content-Type":"application/x-amz-json-1.1"},
  //   data : {ClientId: clientId, Username: username,ConfirmationCode:conformationCode,Password:password}  ,
  // };
  // return axios(config);

}

export const GetUser = (accessToken)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/getuser",
    headers :{"Content-Type":"application/json"},
    data : {AccessToken: accessToken} ,
  };
  return axios(config);
}


export const AssociateSoftwareToken = (accessToken)  => {
    var config ={ 
      method: 'POST',
      url: appURL+"/associatesoftwaretoken",
      headers :{"Content-Type":"application/json"},
      data : {AccessToken: accessToken} ,
    };
    return axios(config);
}

export const VerifySoftwareToken = (accessToken,friendlyDeviceName,userCode)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/verifysoftwaretoken",
    headers :{"Content-Type":"application/json"},
    data : {AccessToken: accessToken,FriendlyDeviceName:friendlyDeviceName,UserCode:userCode} ,
  };
  return axios(config);
}

export const SetUserMFAPreference = (accessToken,smsEnabled,authAppEnabled,emailEnabled)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/setusermfapreference",
    headers :{"Content-Type":"application/json"},
    data : {AccessToken: accessToken,
           smsenabled:smsEnabled,
           authAppEnabled:authAppEnabled,
           emailEnabled:emailEnabled,
         }  ,
  };
  return axios(config);
}

export const answerResetPassword = (username,password,session,clientId)  => {
  var config ={ 
    method: 'POST',
    url: appURL+"/signin/resetpassword",
    headers :{"Content-Type":"application/json"},
    data : {ChallengeName: "NEW_PASSWORD_REQUIRED", ChallengeResponses: {USERNAME: username, NEW_PASSWORD : password}, ClientId: clientId,Session: session}  ,
  };
  return axios(config);
}

export const writeauth = (username,AuthenticationResult)=>{
  var config ={ 
    method: 'POST',
    url: appURL+"/signin/writeauth",
    headers :{"Content-Type":"application/json"},
    data : {username: username, AuthenticationResult:AuthenticationResult}  ,
  };
  return axios(config);
}

export const updateEmail = (accesToken,newEmail)=>{
  var config ={ 
    method: 'POST',
    url: appURL+"/updateuserattributes",
    headers :{"Content-Type":"application/json"},
    data : {AccessToken: accesToken, name:"email",value:newEmail}  ,
  };
  return axios(config);
}
export const updatePhone = (accesToken,newEmail)=>{
  var config ={ 
    method: 'POST',
    url: appURL+"/updateuserattributes",
    headers :{"Content-Type":"application/json"},
    data : {AccessToken: accesToken, name:"phone_number",value:newEmail}  ,
  };
  return axios(config);
}
export const updateMFAPreference = (accesToken,mfapref)=>{
  var config ={ 
    method: 'POST',
    url: appURL+"/updateuserattributes",
    headers :{"Content-Type":"application/json"},
    data : {AccessToken: accesToken, name:"custom:mfapreference",value:mfapref}  ,
  };
  return axios(config);
}